

export const PAP_TEST_TYPE = 'PapTest';
export const PAP_TEST_CODE = '131';